export default __webpack_public_path__ + "static/media/4mmb.f073c62e.jpg";